import { log } from '../../../utils/log';
import React from 'react';
import { KendoError } from '../simple-styled-components';

export default class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    log.error(error);
    return { hasError: true };
  }

  render() {
    if ((this.state as any).hasError) {
      return <KendoError>Unable to render this field</KendoError>;
    }

    return this.props.children;
  }
}
